import React, { Component } from 'react';

import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// Component styles
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import styles from './styles';
import moment from 'moment'
import Filter from '../../../../../helpers/Filter'
import 'moment/locale/es'  
moment.locale('es')




class Header extends Component {
    
    constructor(props) {
        
        super(props);
        this.InfoAutoComplete = this.handlePlataform.bind(this);
        this.InfoAutoComplete = this.handleGroup.bind(this);
        this.InfoAutoComplete = this.handleObj.bind(this);
        // console.log(this.props.objectives)
        // console.log( this.props.objectives.map((obj) => ({
        //     ...obj,
        //     nombre: obj.nombre +"/"+obj.nombre_paso
        //   })))      
        this.state = {
            activeStep:0,
            steps:['Seleccione Plataforma', 'Seleccione Sitio', 'Seleccione Objetivo'],
            listPlataform:[{"nombre":"App"},{"nombre":"Desktop"}],
            listGroup:[{"nombre":"Sitio Publico"},{"nombre":"Sitio Privado"}],
            objectives:this.props.objectives.map((obj) => ({
                ...obj,
                nombre: obj.nombre +"/"+obj.nombre_paso
              })),
            plataform:"App",
            group:"Publico",
            setObjective:this.props.objectives.map((obj) => ({
                ...obj,
                nombre: obj.nombre +"/"+obj.nombre_paso
              }))[0],
            handleSelect:false
        }
        
    }

    handleObj=(tag, info)=>{
        //console.log('set', tag, this.state.setObjective.nombre)
        
        if(tag==="Objetivos"){
            
            //console.log('handle', info.nombre, info.objetivo_id)
            this.setState({
                setObjective:info,
                handleSelect:true
            });
        }else{
            //console.log('no selecciona', info[0].nombre, info[0].objetivo_id)
            this.setState({
                setObjective:info[0],
                handleSelect:false
            });
        }
        
    }

    handleGroup=(tag, info)=>{
        const {listGroup, group}=this.state
        if(info.nombre==="Sitio Privado"){
            this.setState({
                group:"Privado",
                listGroup:[{"nombre":"Sitio Privado"},{"nombre":"Sitio Publico"}],
            });
        }else{
            this.setState({
                group:"Publico",
                listGroup:[{"nombre":"Sitio Publico"},{"nombre":"Sitio Privado"}],
            });
        }
    }

    handlePlataform=(tag, info)=>{
        const {listPlataform,plataform}=this.state
        if(info.nombre==="Desktop"){
            this.setState({
                plataform:"Desktop",
                listPlataform:[{"nombre":"Desktop"},{"nombre":"App"}],
            });
        }else{
            this.setState({
                plataform:"App",
                listPlataform:[{"nombre":"App"},{"nombre":"Desktop"}],
            });
        }
    }

    getGroup=(list, group)=>{
        var filterObj=[]
        if(group==="Publico"){
            filterObj=list.filter(ele=>ele.publico==="true")
        }else{
            filterObj=list.filter(ele=>ele.privado==="true")
        }
        return filterObj
    }

    getStepContent=(step)=> {
        const {listPlataform, listGroup, objectives, group, plataform}=this.state
        var filterObj=objectives
        if(plataform!=="App"){
            filterObj=objectives.filter(ele=>ele.servicio!==700)
        }else{
            filterObj=objectives.filter(ele=>ele.servicio===700)
        }
        filterObj=this.getGroup(filterObj, group)
        var plat=<Grid
                    container
                    spacing={2}
                >
                    <Filter  list={listPlataform} label="Plataforma" placeholder="Filtro de Plataforma" InfoAutoComplete={this.handlePlataform}/>
            </Grid>
        var groups=<Grid
                        container
                        spacing={2}
                    >
                        <Filter  list={listGroup} label="Sitios" placeholder="Seleccione Sitio" InfoAutoComplete={this.handleGroup}/>
                    </Grid>
        var objectivesList=<Grid
                        container
                        spacing={2}
                    >
                        <Filter  list={filterObj} label="Objetivos" placeholder="Filtro de Objetivos" InfoAutoComplete={this.handleObj}/>
                    </Grid>
        
        switch (step) {
          case 0:
            return plat
          case 1:
            return groups
          case 2:
            return objectivesList
          default:
            return 'Error desconocido';
        }
    }

    handleSetObj=(list, boolean)=>{
        const {setObjective}=this.state
        if(boolean===true){
            this.props.setObjective(setObjective)
        }else{
            this.props.setObjective(list[0])
        }

    }
    handleNext = () => {
        const {activeStep, group, plataform, objectives, setObjective, handleSelect}=this.state
        if(activeStep===2){
            //console.log('next', handleSelect, setObjective.nombre, setObjective.objetivo_id)
            //this.props.setObjective(setObjective)
            if(plataform==="Desktop"){
                if(group==="Publico"){
                    this.handleObj("",objectives.filter(ele=>ele.servicio!==700&&ele.publico==="true"))
                    this.handleSetObj(objectives.filter(ele=>ele.servicio!==700&&ele.publico==="true"), handleSelect)
                    this.setState({
                        listPlataform:[{"nombre":"Desktop"},{"nombre":"App"}],
                        listGroup:[{"nombre":"Sitio Publico"},{"nombre":"Sitio Privado"}],
                        activeStep:0
                    });
                }else{
                    this.handleObj("",objectives.filter(ele=>ele.servicio!==700&&ele.privado==="true"))
                    this.handleSetObj(objectives.filter(ele=>ele.servicio!==700&&ele.privado==="true"), handleSelect)
                    this.setState({
                        listPlataform:[{"nombre":"Desktop"},{"nombre":"App"}],
                        listGroup:[{"nombre":"Sitio Privado"},{"nombre":"Sitio Publico"}],
                        activeStep:0
                    });
                }
            }else{
                if(group==="Publico"){
                    this.handleObj("",objectives.filter(ele=>ele.servicio===700&&ele.publico==="true"))
                    this.handleSetObj(objectives.filter(ele=>ele.servicio===700&&ele.publico==="true"), handleSelect)
                    this.setState({
                        listPlataform:[{"nombre":"App"},{"nombre":"Desktop"}],
                        listGroup:[{"nombre":"Sitio Publico"},{"nombre":"Sitio Privado"}],
                        activeStep:0
                    });
                }else{
                    this.handleObj("",objectives.filter(ele=>ele.servicio===700&&ele.privado==="true"))
                    this.handleSetObj(objectives.filter(ele=>ele.servicio===700&&ele.privado==="true"), handleSelect)
                    this.setState({
                        listPlataform:[{"nombre":"App"},{"nombre":"Desktop"}],
                        listGroup:[{"nombre":"Sitio Privado"},{"nombre":"Sitio Publico"}],
                        activeStep:0
                    });
                }
            }
        }else{
            this.setState({
                activeStep:activeStep + 1
            });
        }
        
      };
    
    handleBack = () => {
        const {activeStep}=this.state
        this.setState({
            activeStep:activeStep - 1
        });
      };

    render() {
        const {activeStep, steps, setObjective}=this.state
        const {classes}= this.props
        return(
            <Grid
              item
              xs={10}
              sm={10}
              md={10}
              xl={10}
              style={{textAlign:"left"}}  
            >
                <Stepper activeStep={activeStep} orientation="horizontal" >
                    {steps.map((label, index) => (
                    <Step key={label} style={{width:"22%"}}>
                        <StepLabel
                            StepIconProps={{
                                classes: {
                                  root: classes.icon,
                                  active: classes.icon,
                                  completed: classes.icon
                                }
                            }}
                        >{label}</StepLabel>
                        <StepContent style={{width:"100%"}}>
                            <Typography>{this.getStepContent(index)}</Typography>
                            <div className={classes.actionsContainer} >
                                <div>
                                <Button
                                    disabled={activeStep === 0}
                                    onClick={this.handleBack}
                                    className={classes.button}
                                >
                                    Atras
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={this.handleNext}
                                    className={classes.buttonNext}
                                >
                                    {activeStep === steps.length - 1 ? 'Filtrar' : 'Adelante'}
                                </Button>
                                </div>
                            </div>
                        </StepContent>
                    </Step>
                    ))}
                </Stepper>
                {activeStep === steps.length && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography>All steps completed - you&apos;re finished</Typography>
                    <Button onClick={this.handleReset} className={classes.button}>
                        Reset
                    </Button>
                    </Paper>
                )}
            </Grid>
        )
    }
}



//export default (Movistar);

export default compose(withStyles(styles))(Header);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Movistar/Header/index.jsx